"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeFramedScreenContainer = exports.FramedScreenContainer = void 0;
const ValueObjects_1 = require("../ValueObjects");
const MemoizedBoolean_1 = require("./MemoizedBoolean");
const MemoizedVector2_1 = require("./MemoizedVector2");
const ObservableEntity_1 = require("./ObservableEntity");
class FramedScreenContainer extends ObservableEntity_1.ObservableEntity {
}
exports.FramedScreenContainer = FramedScreenContainer;
function makeFramedScreenContainer(id) {
    return new FramedScreenContainerImp(id);
}
exports.makeFramedScreenContainer = makeFramedScreenContainer;
class FramedScreenContainerImp extends FramedScreenContainer {
    constructor(id) {
        super();
        this.memozedPos = new MemoizedVector2_1.MemoizedVector2(ValueObjects_1.Vector2.Zero(), this.notify);
        this.memozedSize = new MemoizedVector2_1.MemoizedVector2(ValueObjects_1.Vector2.Zero(), this.notify);
        this.memoizedShow = new MemoizedBoolean_1.MemoizedBoolean(true, this.notify);
        this.id = id;
    }
    get position() {
        return this.memozedPos.val;
    }
    set position(p) {
        this.memozedPos.val = p;
    }
    get size() {
        return this.memozedSize.val;
    }
    set size(s) {
        this.memozedSize.val = s;
    }
    get show() {
        return this.memoizedShow.val;
    }
    set show(s) {
        this.memoizedShow.val = s;
    }
}
